<div class="footer-container">
	<app-not-authorized-notice has="userRoleManagement"></app-not-authorized-notice>

	<div class="content-container" [appHasSystemCapability] has="userRoleManagement">
		<app-user-search-bar
			#userSearchBarComponent
			[searchAllUsers]="true"
			(selectedUserEvents)="onUserSelectedEvent($event)"
		></app-user-search-bar>
		<button
			mat-flat-button
			class="primary-button"
			style="max-width: 150pt; margin-left: 24px; margin-bottom: 24px"
			#addUserButton
			(click)="onAddUserClicked()"
			[disabled]="true"
			data-automation-id="create-new-user-button"
			i18n="@@addRoleUsers-createNewUserButton"
		>
			+ Create New User
		</button>
	</div>

	@if (dataSource.data.length > 0) {
		<div class="content-container spacing-24 add-users-container">
			<div style="padding-top: 16px; padding-left: 8px; color: #006f95">
				<b i18n="@@addRoleUsers-incomingUsersLabel">Incoming Users</b>
			</div>
			<table mat-table [dataSource]="dataSource" class="add-users-table">
				<ng-container matColumnDef="name">
					<td mat-cell *matCellDef="let element">{{ element.user.firstName }} {{ element.user.lastName }}</td>
				</ng-container>
				<ng-container matColumnDef="email">
					<td mat-cell *matCellDef="let element">{{ element.user.email }}</td>
				</ng-container>
				<ng-container matColumnDef="phoneNumber">
					<td mat-cell *matCellDef="let element">{{ element.user.phoneNumber?.rawPhoneNumber }}</td>
				</ng-container>
				<ng-container matColumnDef="remove">
					<td mat-cell *matCellDef="let element">
						<button
							mat-flat-button
							style="color: #db5555"
							(click)="removeUser(element)"
							i18n="@@addRoleUsers-removeButton"
							[attr.data-automation-id]="'remove-user-' + element.id + '-button'"
						>
							Remove
						</button>
					</td>
				</ng-container>
				<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
			</table>
		</div>
	}
</div>
